export default [
    {
      path: '/finalizar-compra',
      name: 'finalizar_compra',
      component: () => import('@/views/orden/Checkout.vue'),
      meta: {
        layout: 'full',
        requiresAuth: false,
      },
    },
    {
      path: '/compra/:token',
      name: 'verificar_compra',
      component: () => import('@/views/orden/VerificarCheckout.vue'),
      meta: {
        layout: 'full',
        requiresAuth: false,
      },
    }
]
